<template>

    <div>
        <span class="alarmeJeObjektkategorie" v-if="chartdata">
           <horizontal-bar-chart
                   v-if="loaded"
                   v-on:set-chart="setChart"
                   :chartdata="chartdata"
                   :options="options"
           />
        </span>
        <div v-else-if="!chartdata && !loaded" class="text-center">
            <SpinnerImage />
        </div>
    </div>

</template>

<script>

    import axios from 'axios'
    axios.defaults.withCredentials = true
    import HorizontalBarChart from '@/components/charts/HorizontalBarChart'
    import SpinnerImage from '@/components/layout/SpinnerImage'
    import bootbox from 'bootbox'

    export default {
      name: 'BarChartAlarmeJeObjektkategorieTraplinked',
      components: {
        HorizontalBarChart,
        SpinnerImage
      },
      props: ['traplinkedbericht', 'filter'],
      data () {
        return {
          loaded: false,
          /** Daten für den Bar Chart */
          chartdata: null,
          options: {
            onClick: this.chartClickEvent,
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              title: {
                display: true,
                text: this.$t('message.charts_alarme_je_objektkategorie')
              },
              tooltip: {
                callbacks: {
                  label: function (ctx) {
                    let label = ctx.dataset.label || ''
                    if (label) {
                      label += ': ' + ctx.parsed.x
                    }
                    return label + ' %';
                  }
                }
              }
            },
            scales: {
              x: {
                beginAtZero: true,
                stacked: true,
                ticks: {
                  callback: function (value) { if (Number.isInteger(value)) { return value + '%'; } },
                  stepSize: 10
                }
              },
              y: {
                stacked: true
              }
            }
          },
          /** Chart.js Chart */
          chart: null,
          /** Filter der Charts */
          filterung: {
            /** Filter nach einer Objektkategorie */
            filterObjektkategorie: null,
            /** Filter nach einer Area */
            filterArea: null,
          }
        }
      },
      watch: {
        traplinkedbericht: function () {
          this.init()
        },
        filter: {
          handler: function (newObj) {
            console.log('Filter in BarChartAlarmeJeObjektkategorieTraplinked geändert ' + newObj)
            this.filterung = newObj
            this.init()
          },
          deep: true
        }
      },
      created () {
        this.init()
      },
      methods: {

        /**
         * Chart des Parents zurückliefern um Klick Events zu behandeln
         */
        setChart: function (obj) {
          console.log('set chart BarChartAlarmeJeObjektkategegorieTralinked: ' + obj)
          this.chart = obj
        },
        /**
         * Klick auf den Chart, Filter setzen
         * @param event click Event
         */
        chartClickEvent: function (event) {

          console.log('chartClickEvent ' + event)
          const elements = this.chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true)
          if (elements && elements.length > 0) {
            const idx = elements[0].index
            console.log('index = ' + idx)
            const label = this.chart.config.data.labels[idx]
            console.log('label = ' + label)
            if (label == 'Mängel') {
              bootbox.alert(this.$t('message.bar_chart_alarme_je_objektkategorie_maengel'))
              return
            }
            if (label) {
              this.filterObjektkategorie(label)
            }
          }

        },
        /**
         * nach einer Objektkategorie filtern
         * @param label Objekttyp Bezeichnung
         */
        filterObjektkategorie: function (label) {

          if (label) {
            console.log('Filter Objektkategorie gesetzt: ' + label)
            this.filterung.filterObjektkategorie = label
            this.$emit('filter-objektkategorie', label)
          }

        },
        init: async function () {

          this.loaded    = false
          this.chartdata = null
          if (this.traplinkedbericht) {

            const url     = process.env.VUE_APP_SERVER_URL + '/datenbroker/getChartDataOfBesuchsbericht'
            const params  = {
              traplinkedbericht_id:     this.traplinkedbericht.id,
              type:                     'BAR_CHART_ALARME_JE_OBJEKTKATEGORIE_TRAPLINKED',
              filterArea:               this.filterung ? this.filterung.filterArea : null,
              areasAllowed:             this.$store.getters.benutzerrechte ? this.$store.getters.benutzerrechte.showAreas : null,
              filterObjektkategorie:    this.filterung ? this.filterung.filterObjektkategorie : null,
            }

            const that = this
            await axios({
              method: 'GET',
              params: params,
              url: url,
            }).then(function (response) {

              if (response.data) {

                that.chartdata = response.data.chartdata
                if (that.chartdata) {

                  const datasets = that.chartdata.datasets
                  if (!datasets) {
                    that.chartdata = null
                  }

                } // end if that.chartdata

              }
              that.loaded = true

            }).catch(error => {
              console.log(error)
              that.loaded = true
            })
          }

        }

      }

    }

</script>
